var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sumoning.length)?_c('div',{staticClass:"summoning-box"},_vm._l((_vm.sumoning),function(item){return _c('SummoningOrderItem',_vm._b({key:item.id},'SummoningOrderItem',item,false))}),1):_c('div',{staticClass:"empty"},[_c('span',[_vm._v("当前还没有召集中的活动发一个试试？")]),_c('button',{on:{"click":_vm.goCreate}},[_vm._v("去发布")])])
}
var staticRenderFns = []

export { render, staticRenderFns }